<form #redirectForm
  [action]="url"
  method="post"
  id="webNGRedirectForm"
  name="autoForm"
  target="_self">
  <input type="hidden"
    name="clientCode"
    [value]="clientCode"/>
    <input type="hidden"
      name="localeTag"
      [value]="localeTag"/>
      @for (extra of redirectExtras | keyvalue; track extra) {
        <input type="hidden"
          [name]="extra.key"
          [value]="typeof(extra.value) === 'string' ? extra.value : stringify(extra.value)"/>
        }
      </form>
